import * as React from 'react'

import { cn } from '../../lib/utils'

/**
 * v5.2 NativeSelect — the native <select> styled via `.ac-select`.
 * Mint caret, 44px height, shared chrome with Input.
 *
 * Use this for simple option lists where the platform picker is
 * appropriate (game system, session cadence, currency). For rich,
 * grouped, searchable menus keep using the Radix-based <Select />
 * from ./select.tsx.
 */
export type NativeSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>

const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, children, ...props }, ref) => (
    <select ref={ref} className={cn('ac-select', className)} {...props}>
      {children}
    </select>
  )
)
NativeSelect.displayName = 'NativeSelect'

export { NativeSelect }
